import React from 'react';

const HeartIcon = ({ fillColor = "#E32652", width = 20, height = 20 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.65 17.8L6.925 16.225C5.15833 14.6083 3.56267 13.004 2.138 11.412C0.712667 9.82066 0 8.06666 0 6.14999C0 4.58333 0.525 3.27499 1.575 2.22499C2.625 1.17499 3.93333 0.649994 5.5 0.649994C6.38333 0.649994 7.21667 0.837327 8 1.21199C8.78333 1.58733 9.45 2.09999 10 2.74999C10.55 2.09999 11.2167 1.58733 12 1.21199C12.7833 0.837327 13.6167 0.649994 14.5 0.649994C16.0667 0.649994 17.375 1.17499 18.425 2.22499C19.475 3.27499 20 4.58333 20 6.14999C20 8.06666 19.2917 9.82499 17.875 11.425C16.4583 13.025 14.85 14.6333 13.05 16.25L11.35 17.8C10.9667 18.15 10.5167 18.325 10 18.325C9.48333 18.325 9.03333 18.15 8.65 17.8Z"
        fill={fillColor}
      />
    </svg>
  );
};

export default HeartIcon;
